import { render, staticRenderFns } from "./AffinityExploration.vue?vue&type=template&id=bcc4ebae&scoped=true"
import script from "./AffinityExploration.vue?vue&type=script&lang=js"
export * from "./AffinityExploration.vue?vue&type=script&lang=js"
import style0 from "./AffinityExploration.vue?vue&type=style&index=0&id=bcc4ebae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc4ebae",
  null
  
)

export default component.exports